/**
 * Shared auth constants and utilities.
 * Allows API layer to trigger logout on 401 without importing AuthContext.
 */
export const TOKEN_KEY = 'pnid_auth_token';

let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: () => void): void {
  onUnauthorized = cb;
}

export function triggerUnauthorized(): void {
  onUnauthorized?.();
}
